export const DROPMENU_AUTO_WIDTH_COLLECTION = [
  // 'products',
  // 'community',
  // 'explore',
  // 'support',
]
